import { render, staticRenderFns } from "./MlbOptimizerTable.vue?vue&type=template&id=22e5805c&scoped=true"
import script from "./MlbOptimizerTable.vue?vue&type=script&lang=js"
export * from "./MlbOptimizerTable.vue?vue&type=script&lang=js"
import style0 from "./MlbOptimizerTable.vue?vue&type=style&index=0&id=22e5805c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e5805c",
  null
  
)

export default component.exports